/* eslint-disable eqeqeq */
import { autoCompleteErrorStyles } from '../../../styles/makesStyles'
import { ChooseImageButton, CancelButton, SubmitButton } from '../../../input/Buttons'
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker'
import { DispatchContext, LookupContext } from '../../../store'
import { formatter, formatDate, shorten, readableBytes, returnDate } from '../../../common/helpers'
import {
	GET_ART_COA_LOCATION_HISTORY,
	CREATE_COA_LOCATION_HISTORY,
	DELETE_ART_COA_LOCATION,
	UPDATE_ART_COA_LOCATION,
	SIMPLE_SEARCH_LOCATION,
	SIMPLE_SEARCH_SUB_LOCATION,
	SIMPLE_SEARCH_VIA,
} from './Queries'

import {
	Paper,
	TableContainer,
	Table,
	TableHead,
	TableCell,
	TableRow,
	TableBody,
	ListItem,
	ListItemText,
	FormControl,
	CircularProgress,
	MenuItem,
	Menu,
	IconButton,
	Select,
	Skeleton,
} from '@mui/material'
import { severity } from '../../../Snackbar/CustomizedSnackbar'
import { Pagination } from '@mui/material'
import { useQuery, useMutation } from '@apollo/client'
import { withApollo } from '@apollo/client/react/hoc'
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded'
import Label from '../../../input/Label'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'
import NumberFormat from 'react-number-format'
import React, { useCallback, useContext } from 'react'
import TextBox from '../../../input/Text/TextBox'
import TransitionsModal from '../../../navigation/TransitionsModal/TransitionsModal'
import ConfirmationDialog from '../../../navigation/ConfirmationDialog/ConfirmationDialog'
import InfoCard from '../../../InfoCard/InfoCard'
import Dropdown from '../../../input/Dropdown/Dropdown'
import { getFileType } from '../../../Files/FileList'
import Thumbnail from '../../../Thumbnail/Thumbnail'
import UploadModal from '../../../Files/UploadModal'
import { GET_DOWNLOAD_LINK, GET_PREVIEW_LINK } from '../../../Files/Queries'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'
import TextBoxThinForAutocomplete from '../../../input/Text/TextBoxThinForAutocomplete'
import LimitedAutocomplete from '../../../common/LimitedAutocomplete'

const initialState = {
	mouseX: null,
	mouseY: null,
	editable: false,
}

const ArtCoaLocation = (props) => {

	const classes = autoCompleteErrorStyles()

	// Location History
	const [tempRows, setTempRows] = React.useState([])
	const [rows, setRows] = React.useState([])
	const [currentRow, setCurrentRow] = React.useState(null)
	const [currentFile, setCurrentFile] = React.useState(null)

	const [cursor, setCursor] = React.useState(0)
	const [activeStep, setActiveStep] = React.useState(null)
	const [totalItems, setTotalItems] = React.useState(0)
	const [steps, setSteps] = React.useState(0)

	const [coaLocationModal, setCoaLocationModal] = React.useState({ open: false })

	const [state, setState] = React.useState(initialState)
	const [infoObject, setInfoObject] = React.useState(null)
	const [uploadModal, setUploadModal] = React.useState(false)
	const [toggleUserDialog, setToggleUserDialog] = React.useState(false)

	const [anchorEl, setAnchorEl] = React.useState(null)
	const handleFileClick = (event) => setAnchorEl(event.currentTarget)
	const handleFileClose = () => setAnchorEl(null)
	const [editMode, setEditMode] = React.useState(false)

	const lookup = useContext(LookupContext)
	const currencies = lookup.data?.getCurrencies
	const statuses = lookup.data?.getArtCoaStatuses
	const itemsPerPage = 5

	const [createCoaLocation, { loading: createLoading }] = useMutation(CREATE_COA_LOCATION_HISTORY, {
		onError: (error) => {
			openSnackbar(severity.ERROR, 'Could not create art CoA location.')
			console.error(error)
		},
		onCompleted: (response) => {
			if (response.createArtCoaLocation.success === true) {
				// Success
				openSnackbar(severity.SUCCESS, response.createArtCoaLocation.message)

				refetch({
					variables: {
						id: props.art.id,
						cursor: 0,
						limit: itemsPerPage
					},
				}).then(({ data }) => {
					const updatedRows = data.getArtCoaLocationHistory.items
					props.setArt({
						...props.art,
						art_coa_location: updatedRows
					})
					setRows(updatedRows)
				}).catch((_) => {
					openSnackbar(severity.ERROR, 'There was an error while refetching.')
				})

				setAttempt(false)
				setCoaLocationModal({
					open: false,
					input: {
						location_id: null,
						sub_location_id: null,
						via_id: null,
						location_change_at: new Date(),
						estimated_shipping_cost: null,
						final_shipping_cost: null,
						currency_id: 1,
						tracking_number: null,
						status_id: 1,
						files: [],
					},
				})
			} else {
				// Error
				openSnackbar(severity.ERROR, response.createArtCoaLocation.message)
			}
		},
	})

	const [updateLocation, { loading: updateLoading }] = useMutation(UPDATE_ART_COA_LOCATION, {
		onError: (error) => {
			console.error(error)
			openSnackbar(severity.ERROR, 'Could not update art CoA location.')
		},
		onCompleted: (response) => {
			if (response.updateArtCoaLocation.success === true) {
				// Success
				openSnackbar(severity.SUCCESS, response.updateArtCoaLocation.message)

				refetch({
					variables: {
						id: props.art.id,
						cursor: 0,
						limit: itemsPerPage
					},
				}).then(({ data }) => {

					const updatedRows = data.getArtCoaLocationHistory.items
					props.setArt({
						...props.art,
						art_coa_location: updatedRows
					})
					setRows(updatedRows)


				}).catch((_) => {
					openSnackbar(severity.ERROR, 'There was an error while refetching.')
				})

				setCoaLocationModal({
					open: false,
					input: {
						...coaLocationModal.input,
						files: response.updateArtCoaLocation.ArtCoaLocation.files
					},
				})

				setAttempt(false)

			} else {
				// Error
				openSnackbar(severity.ERROR, response.updateArtCoaLocation.message)
			}
		},
	})

	const [deleteArtCoaLocation] = useMutation(DELETE_ART_COA_LOCATION, {
		onError: (error) => {
			console.error(error)
			openSnackbar(severity.ERROR, 'Could not delete art CoA location.')
		},
		onCompleted: (response) => {
			if (response.deleteArtCoaLocation.success) {
				openSnackbar(severity.SUCCESS, response.deleteArtCoaLocation.message)
				setRows(rows.filter((row) => row.id != currentRow?.id))
				setTempRows(tempRows.filter((row) => row.id != currentRow?.id))
				setState(initialState)
			}

			refetch({
				variables: {
					id: props.art.id,
					cursor: 0,
					limit: itemsPerPage
				},
			}).then(({ data }) => {
				const updatedRows = data.getArtCoaLocationHistory.items
				props.setArt({
					...props.art,
					art_coa_location: updatedRows
				})
				setRows(updatedRows)
			}).catch((_) => {
				openSnackbar(severity.ERROR, 'There was an error while refetching.')
			})

			setAttempt(false)
			setCoaLocationModal({
				open: false,
				input: {
					location_id: null,
					sub_location_id: null,
					via_id: null,
					location_change_at: new Date(),
					estimated_shipping_cost: null,
					final_shipping_cost: null,
					tracking_number: null,
					status_id: 1,
					currency_id: 1,
				},
			})
		},
	})

	const handleClick = (event) => {
		event.preventDefault()
		setState({
			mouseX: event.clientX - 2,
			mouseY: event.clientY - 4,
			editable: false,
		})
	}

	const handleClose = (option) => {
		if (option === 'edit') {
			const {
				id,
				location_id,
				sub_location_id,
				via_id,
				location_change_at,
				estimated_shipping_cost,
				final_shipping_cost,
				currency_id,
				tracking_number,
				status_id,
				files,
			} = currentRow

			setCoaLocationModal({
				open: true,
				input: {
					id,
					location_id,
					sub_location_id,
					via_id,
					location_change_at: returnDate(location_change_at),
					estimated_shipping_cost,
					final_shipping_cost,
					currency_id,
					tracking_number,
					status_id,
					files,
				},
			})

			setState(initialState)
		} else if (option === 'information') {
			setInfoObject(currentRow)
			setState(initialState)
		} else if (option === 'delete') {
			setToggleUserDialog(true)
			setState(initialState)
		} else {
			setState(initialState)
		}
	}

	const handleSubmit = (cursor = 0) => {
		setCursor(cursor)
	}

	//Snackbar
	const dispatch = useContext(DispatchContext)
	const openSnackbar = useCallback(
		(severity, text) => {
			dispatch({ type: 'openSnackBar', payload: { severity, text } })
		},
		[dispatch]
	)

	const [attempt, setAttempt] = React.useState(false)

	const { loading, data, refetch } = useQuery(GET_ART_COA_LOCATION_HISTORY, {
		variables: {
			id: props.art.id,
			cursor,
			limit: itemsPerPage
		},
		skip: !props?.art?.id,
	})

	React.useEffect(() => {
		setRows(data?.getArtCoaLocationHistory?.items || [])
		const nItems = data?.getArtCoaLocationHistory.totalItems

		if (nItems < 1 || !nItems) {
			setSteps(1)
		} else {
			setSteps((Math.ceil(nItems / itemsPerPage)))
		}

		setTotalItems(nItems)


		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [data])

	const [locationOpen, setLocationOpen] = React.useState(false)
	const [locationOptions, setLocationOptions] = React.useState([])
	const [loadLocation, setLoadLocation] = React.useState(false)
	const locationLoading = locationOpen && !!loadLocation
	const [locationValue, setLocationValue] = React.useState(null)

	const [subLocationOpen, setSubLocationOpen] = React.useState(false)
	const [subLocationOptions, setSubLocationOptions] = React.useState([])
	const [loadSubLocation, setLoadSubLocation] = React.useState(false)
	const subLocationLoading = subLocationOpen && !!loadSubLocation
	const [subLocationValue, setSubLocationValue] = React.useState(null)

	const [viaOpen, setViaOpen] = React.useState(false)
	const [viaOptions, setViaOptions] = React.useState([])
	const [loadVia, setLoadVia] = React.useState(false)
	const viaLoading = viaOpen && !!loadVia
	const [viaValue, setViaValue] = React.useState(null)

	React.useEffect(() => {
		if (currentRow) {
			setLocationOptions([currentRow.location])
			setLocationValue(currentRow.location)
			setSubLocationOptions(currentRow.sub_location ? [currentRow.sub_location] : [])
			setSubLocationValue(currentRow.sub_location ? currentRow.sub_location : null)
			setViaOptions(currentRow.via ? [currentRow.via] : [])
			setViaValue(currentRow.via ? currentRow.via : null)
		}
	}, [currentRow])

	React.useEffect(() => {
		let active = true

		if (!locationLoading) {
			return undefined
		}

		props.client
			.query({
				query: SIMPLE_SEARCH_LOCATION,
				variables: { query: loadLocation },
			})
			.then((result) => {
				if (active) {
					setLoadLocation(false)
					setLocationOptions(result.data?.simpleSearchLocation || [])
				}
			})


		return () => {
			active = false
		}
	}, [loadLocation, locationLoading, props.client])

	React.useEffect(() => {
		let active = true

		if (!subLocationLoading) {
			return undefined
		}

		props.client
			.query({
				query: SIMPLE_SEARCH_SUB_LOCATION,
				variables: { query: loadSubLocation },
			})
			.then((result) => {
				if (active) {
					setLoadSubLocation(false)
					setSubLocationOptions(result.data?.simpleSearchSubLocation || [])
				}
			})


		return () => {
			active = false
		}
	}, [loadSubLocation, subLocationLoading, props.client])


	React.useEffect(() => {
		let active = true

		if (!viaLoading) {
			return undefined
		}


		props.client
			.query({
				query: SIMPLE_SEARCH_VIA,
				variables: { query: loadVia },
			})
			.then((result) => {
				if (active) {
					setLoadVia(false)
					setViaOptions(result.data?.simpleSearchVia || [])
				}
			})


		return () => {
			active = false
		}
	}, [loadVia, viaLoading, props.client])

	return <>
		<Paper
			className="qv-margin"
			id="location-history"
			data-testid="card-location-history"
		>
			<h1 className="card-title">
				<span>
					Certificate of Authenticity {totalItems ? `(${totalItems})` : ''}
				</span>
				<>
					<div className="spacer"></div>
					<Pagination
						style={{
							paddingRight: '1em',
						}}
						size="small"
						count={steps}
						siblingCount={0}
						page={activeStep + 1}
						onChange={(event, page) => {
							setActiveStep(page - 1)
							handleSubmit((page - 1) * itemsPerPage)
						}}
					>
					</Pagination>
					<ChooseImageButton
						variant="contained"
						color="secondary"
						size="small"
						onClick={() => {
							setCurrentRow(null)
							setCoaLocationModal({
								open: true,
								input: {
									location_id: null,
									sub_location_id: null,
									via_id: null,
									location_change_at: new Date(),
									estimated_shipping_cost: null,
									final_shipping_cost: null,
									currency_id: 1,
									tracking_number: null,
									status_id: 1,
									files: [],
								},
							})
						}}
					>
						Add
					</ChooseImageButton>
				</>
			</h1>

			<TableContainer
				style={{
					overflowX: 'auto',
					height: '90%',
				}}
			>
				<Table>
					<TableHead>
						<TableRow>
							<TableCell>Location &amp; Sub-Location</TableCell>
							<TableCell>Via</TableCell>
							<TableCell>
								Date
								<IconButton size="small" disabled>
									<ArrowDownwardIcon style={{ fontSize: '1rem', marginBottom: '.2em' }} />
								</IconButton>
							</TableCell>
							<TableCell>Estimated Shipping Costs</TableCell>
							<TableCell>Final Shipping Costs</TableCell>
							<TableCell>Tracking Number</TableCell>
							<TableCell>Status</TableCell>
							<TableCell>User</TableCell>
							<TableCell></TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{rows?.length
							? rows.map((row) => {
								return (
									<TableRow key={`history-${row.id}`}>
										<TableCell>
											<ListItem style={{ padding: '0' }}>
												<ListItemText
													primary={row.location?.name}
													secondary={row.sub_location?.name}
												/>
											</ListItem>
										</TableCell>
										<TableCell>{row.via?.name || '-'}</TableCell>
										<TableCell>
											{row.location_change_at
												? formatDate(row.location_change_at, 'MMMM do, yyyy')
												: '-'}
										</TableCell>
										<TableCell>
											{row.estimated_shipping_cost
												? `${formatter(row.currency.label || 'USD').format(
													row.estimated_shipping_cost
												)}`
												: '-'}
										</TableCell>
										<TableCell>
											{row.final_shipping_cost
												? `${formatter(row.currency.label || 'USD').format(
													row.final_shipping_cost
												)}`
												: '-'}
										</TableCell>

										<TableCell>{row.tracking_number ? row.tracking_number : '-'}</TableCell>
										<TableCell>{row.status?.value}</TableCell>
										<TableCell>{row.modified_user.first_name + ' ' + row.modified_user.last_name}</TableCell>


										<TableCell>
											<IconButton
												aria-label="More"
												style={{
													padding: '6px',
													marginRight: '-9px',
												}}
												onClick={(e) => {
													e.preventDefault()
													e.stopPropagation()
													setCurrentRow(row)
													handleClick(e)
												}}
												size="large">
												<MoreHorizIcon />
											</IconButton>
										</TableCell>
									</TableRow>
								)
							})
							: null}

						{loading ? <TableRow key="placeholder">
							<TableCell><Skeleton animation="wave"/></TableCell>
							<TableCell><Skeleton animation="wave"/></TableCell>
							<TableCell><Skeleton animation="wave"/></TableCell>
							<TableCell><Skeleton animation="wave"/></TableCell>
							<TableCell><Skeleton animation="wave"/></TableCell>
							<TableCell><Skeleton animation="wave"/></TableCell>
							<TableCell><Skeleton animation="wave"/></TableCell>
							<TableCell><Skeleton animation="wave"/></TableCell>
							<TableCell></TableCell>
						</TableRow> : null }

						{!loading && data && rows?.length === 0 ? (
							<TableRow key="placeholder">
								<TableCell>No CoA Location History</TableCell>
								<TableCell></TableCell>
								<TableCell></TableCell>
								<TableCell></TableCell>
								<TableCell></TableCell>
								<TableCell></TableCell>
								<TableCell></TableCell>
								<TableCell></TableCell>
								<TableCell></TableCell>
							</TableRow>
						) : null}
					</TableBody>
				</Table>
			</TableContainer>
		</Paper>

		<TransitionsModal
			className="coa-location-modal"
			open={coaLocationModal.open}
			close={() => {
				setAttempt(false)
				setCoaLocationModal({ ...coaLocationModal, open: false })
				setCurrentRow(null)
			}}
		>
			<div style={{ minWidth: '70em' }} className={props.art?.is_private ? 'private-object' : null}>
				<h1 className="card-title">
					<span>{currentRow ? 'Edit ' : 'New '}Certificate of Authenticity Location</span>
					<>
						<div className="spacer"></div>
						<CancelButton
							variant="contained"
							style={{ float: 'left' }}
							onClick={() => {
								setAttempt(false)
								setCoaLocationModal({
									open: false,
									input: {
										location_id: null,
										sub_location_id: null,
										via_id: null,
										location_change_at: new Date(),
										estimated_shipping_cost: null,
										final_shipping_cost: null,
										currency_id: 1,
										tracking_number: null,
										status_id: 1,
										files: [],
									},
								})
							}}
						>
							Cancel
						</CancelButton>

						<SubmitButton
							style={{
								float: 'right',
								marginLeft: '1em',
							}}
							type="submit"
							variant="contained"
							disabled={updateLoading || createLoading}
							onClick={() => {
								setAttempt(true)

								if (attempt && !coaLocationModal.input.location_id && !coaLocationModal.input.location) {
									openSnackbar(severity.WARNING, 'Please correct field in red.')
								} else if (attempt && coaLocationModal.input.sub_location?.length > 100) {
									openSnackbar(
										severity.WARNING,
										'Sub-Location must be shorter than 100 characters.'
									)
								} else if (!(!coaLocationModal.input.location_id && !coaLocationModal.input.location) &&
									coaLocationModal.input.sub_location?.length <= 100
								) {
									const est_shipping = coaLocationModal.input?.estimated_shipping_cost
									const final_shipping = coaLocationModal.input?.final_shipping_cost

									const variables = {
										...coaLocationModal.input,
										location_change_at: coaLocationModal.input.location_change_at &&
											formatDate(coaLocationModal.input.location_change_at, 'yyyy-MM-dd'),
										art_id: props.art.id,
										estimated_shipping_cost: est_shipping
											? Number(est_shipping)
											: null,
										final_shipping_cost: final_shipping
											? Number(final_shipping)
											: null,
										files: (coaLocationModal.input.files || []).map((file) => {

											const {
												file_group_id,
												user,
												fileCategory,
												__typename,
												fileGroup,
												versionHistory,
												type,
												userName,
												fileObject,
												created_at,
												created_by,
												modified_at,
												modified_by,
												...rest
											} = file

											return { ...rest, version: 1 }
										}),
									}

									if (currentRow) {
										// Update
										updateLocation({
											variables: {
												UpdateArtCoaLocationInput: variables,
											},
										})
									} else {
										// Create
										createCoaLocation({
											variables: {
												CreateArtCoaLocationInput: variables,
											},
										})
									}
								}
							}}
						>
							Save
						</SubmitButton>
					</>
				</h1>

				<div className="row" style={{ justifyContent: 'left' }}>
					<FormControl
						style={{ width: '20em' }}
					>
						<Label
							id="location-label"
							style={{ fontWeight: 500 }}
							disableAnimation
							error={attempt &&
								(!coaLocationModal.input?.location_id &&
									!coaLocationModal.input?.location)
							}
							shrink
						>
							Location*
						</Label>
						<LimitedAutocomplete

							query={loadLocation}
							setQuery={setLoadLocation}

							freeSolo
							id="location-autocomplete"
							classes={classes}
							open={locationOpen}
							onOpen={() => {
								setLocationOpen(true)
							}}
							onClose={() => {
								setLocationOpen(false)
							}}
							style={{ marginTop: '1.5em' }}
							isOptionEqualToValue={(option, value) => option.id == value.id}
							getOptionLabel={(option) => option?.name || option || ''}
							options={locationOptions}
							value={currentRow ? locationValue : null}
							forcePopupIcon
							filterSelectedOptions
							popupIcon={<ExpandMoreRoundedIcon />}
							loading={locationLoading}
							onInputChange={(event, value) => {
								if (!value) {
									setCoaLocationModal({
										...coaLocationModal,
										input: {
											...coaLocationModal.input,
											location_id: null,
											location: null,
										},
									})
								}
							}}
							onChange={(event, value) => {

								if (typeof value === 'string') {
									setCoaLocationModal({
										...coaLocationModal,
										input: {
											...coaLocationModal.input,
											location_id: null,
											location: value,
										},
									})
								}

								else setCoaLocationModal({
									...coaLocationModal,
									input: {
										...coaLocationModal.input,
										location_id: value?.id || null,
										location: null,
									},
								})

							}}
							renderInput={(params) => (
								<TextBoxThinForAutocomplete
									{...params}
									onChange={(event) => {
										setCoaLocationModal({
											...coaLocationModal,
											input: {
												...coaLocationModal.input,
												location: event.target.value,
												location_id: null,
											},
										})
									}}
									variant="outlined"
									error={attempt && !coaLocationModal.input?.location_id && !coaLocationModal.input?.location}
									InputProps={{
										...params.InputProps,
										endAdornment: (
											<React.Fragment>
												{locationLoading ? (
													<CircularProgress color="inherit" size={20} />
												) : null}
												{params.InputProps.endAdornment}
											</React.Fragment>
										),
									}}
								/>
							)}
						/>
					</FormControl>
					<FormControl style={{ width: '20em', marginLeft: '1em' }}>
						<Label id="sub-location-label"
							style={{ fontWeight: 500 }}
							disableAnimation
							shrink
							error={attempt && coaLocationModal.input.sub_location?.length > 100}
						>
							Sub-Location
						</Label>
						<LimitedAutocomplete

							query={loadSubLocation}
							setQuery={setLoadSubLocation}

							freeSolo
							id="sub-location-autocomplete"
							classes={classes}
							open={subLocationOpen}
							onOpen={() => {
								setSubLocationOpen(true)
							}}
							onClose={() => {
								setSubLocationOpen(false)
							}}
							style={{ marginTop: '1.5em' }}
							isOptionEqualToValue={(option, value) => option.id == value.id}
							getOptionLabel={(option) => option.name || option}
							options={subLocationOptions}
							value={currentRow ? subLocationValue : null}
							forcePopupIcon
							filterSelectedOptions
							popupIcon={<ExpandMoreRoundedIcon />}
							loading={subLocationLoading}
							onInputChange={(event, value) => {
								if (!value) {
									setCoaLocationModal({
										...coaLocationModal,
										input: {
											...coaLocationModal.input,
											sub_location_id: null,
											sub_location: null,
										},
									})
								}
							}}
							onChange={(event, value) => {

								if (typeof value === 'string') {
									setCoaLocationModal({
										...coaLocationModal,
										input: {
											...coaLocationModal.input,
											sub_location: value,
											sub_location_id: null,
										},
									})
								}

								else setCoaLocationModal({
									...coaLocationModal,
									input: {
										...coaLocationModal.input,
										sub_location: null,
										sub_location_id: value?.id || null,
									},
								})
							}}
							renderInput={(params) => (
								<TextBoxThinForAutocomplete
									{...params}
									error={attempt && coaLocationModal.input.sub_location?.length > 100}
									onChange={(event) => {
										setCoaLocationModal({
											...coaLocationModal,
											input: {
												...coaLocationModal.input,
												sub_location_id: null,
												sub_location: event.target.value,
											},
										})
									}}
									variant="outlined"
									InputProps={{
										...params.InputProps,
										endAdornment: (
											<React.Fragment>
												{subLocationLoading ? (
													<CircularProgress color="inherit" size={20} />
												) : null}
												{params.InputProps.endAdornment}
											</React.Fragment>
										),
									}}
								/>
							)}
						/>
					</FormControl>
					<FormControl style={{ width: '20em', marginLeft: '1em' }}>
						<Label id="via-label" style={{ fontWeight: 500 }} disableAnimation shrink>
							Via
						</Label>
						<LimitedAutocomplete

							query={loadVia}
							setQuery={setLoadVia}

							freeSolo
							id="via-autocomplete"
							classes={classes}
							open={viaOpen}
							onOpen={() => {
								setViaOpen(true)
							}}
							onClose={() => {
								setViaOpen(false)
							}}
							style={{ marginTop: '1.5em' }}
							isOptionEqualToValue={(option, value) => option.id == value.id}
							getOptionLabel={(option) => option.name || option}
							options={viaOptions}
							value={currentRow ? viaValue : null}
							forcePopupIcon

							filterSelectedOptions
							popupIcon={<ExpandMoreRoundedIcon />}
							loading={viaLoading}
							onInputChange={(event, value) => {
								if (!value) {
									setCoaLocationModal({
										...coaLocationModal,
										input: {
											...coaLocationModal.input,
											via_id: null,
											via: null,
										},
									})
								}
							}}
							onChange={(event, value) => {

								if (typeof value === 'string') {
									setCoaLocationModal({
										...coaLocationModal,
										input: {
											...coaLocationModal.input,
											via: value,
											via_id: null,
										},
									})
								}

								else setCoaLocationModal({
									...coaLocationModal,
									input: {
										...coaLocationModal.input,
										via: null,
										via_id: value?.id || null,
									},
								})

							}}
							renderInput={(params) => (
								<TextBoxThinForAutocomplete
									{...params}
									onChange={(event) => {
										setCoaLocationModal({
											...coaLocationModal,
											input: {
												...coaLocationModal.input,
												via_id: null,
												via: event.target.value,
											},
										})
									}}
									variant="outlined"
									InputProps={{
										...params.InputProps,
										endAdornment: (
											<React.Fragment>
												{viaLoading ? <CircularProgress color="inherit" size={20} /> : null}
												{params.InputProps.endAdornment}
											</React.Fragment>
										),
									}}
								/>
							)}
						/>
					</FormControl>
				</div>

				<div className="row" style={{ justifyContent: 'left' }}>
					<FormControl style={{ width: '20em' }}>
						<Label id="currency-label" disableAnimation shrink>
							Currency
						</Label>

						<Select
							className="padded-select"
							IconComponent={ExpandMoreRoundedIcon}
							name="currency"

							labelId="currency-label"
							input={<Dropdown />}
							value={coaLocationModal.input?.currency_id || ''}
							onChange={(e) => {
								setCoaLocationModal({
									...coaLocationModal,
									input: {
										...coaLocationModal.input,
										currency_id: e.target.value,
									},
								})
							}}
						>
							{currencies?.map((currency) => (
								<MenuItem key={currency.id} value={currency.id}>
									{`${currency.symbol} - ${currency.name}`}
								</MenuItem>
							))}
						</Select>
					</FormControl>

					<FormControl style={{ marginLeft: '1em', width: '20em' }}>
						<Label id="est-cost-label" style={{ fontWeight: 500 }} disableAnimation shrink>
							Estimated Shipping Costs
						</Label>
						<NumberFormat
							id="est-cost"
							customInput={TextBox}
							value={coaLocationModal.input?.estimated_shipping_cost || ''}
							prefix={
								currencies?.find((e) => e.id == coaLocationModal.input?.currency_id)?.symbol || '$'
							}
							placeholder="0"
							thousandSeparator
							allowNegative={false}
							onChange={(e) => {
								setCoaLocationModal({
									...coaLocationModal,
									input: {
										...coaLocationModal.input,
										estimated_shipping_cost: e.target.value.replace(/\D/g, ''),
									},
								})
							}}
							allowLeadingZeros={false}
						/>
					</FormControl>

					<FormControl style={{ marginLeft: '1em', width: '20em' }}>
						<Label id="final-cost-label" style={{ fontWeight: 500 }} disableAnimation shrink>
							Final Shipping Costs
						</Label>
						<NumberFormat
							id="final-cost"
							customInput={TextBox}
							value={coaLocationModal.input?.final_shipping_cost || ''}
							prefix={
								currencies?.find((e) => e.id == coaLocationModal.input?.currency_id)?.symbol || '$'
							}
							placeholder="0"
							allowNegative={false}
							thousandSeparator
							onChange={(e) => {
								setCoaLocationModal({
									...coaLocationModal,
									input: {
										...coaLocationModal.input,
										final_shipping_cost: e.target.value.replace(/\D/g, ''),
									},
								})
							}}
							allowLeadingZeros={false}
						/>
					</FormControl>
				</div>

				<div className="row" style={{ justifyContent: 'left' }}>
					<FormControl style={{ width: '20em' }}>
						<Label id="status-label" disableAnimation shrink>
							Status
						</Label>

						<Select
							className="padded-select"
							IconComponent={ExpandMoreRoundedIcon}
							name="status"

							labelId="status-label"
							input={<Dropdown />}
							value={coaLocationModal.input?.status_id || ''}
							onChange={(e) => {
								setCoaLocationModal({
									...coaLocationModal,
									input: {
										...coaLocationModal.input,
										status_id: e.target.value,
									},
								})
							}}
						>
							{statuses?.map((status) => (
								<MenuItem key={status.id} value={status.id}>
									{`${status.value}`}
								</MenuItem>
							))}
						</Select>
					</FormControl>

					<FormControl style={{ marginLeft: '1em', width: '20em' }}>
						<Label
							id="date-label"
							style={{
								fontWeight: 500,
							}}
							disableAnimation
							shrink
						>
							Date
						</Label>

						<MobileDatePicker
							inputFormat="MMM do, yyyy"
							disableMaskedInput={true}
							cancelText={null}
							name="date"
							inputVariant="outlined"
							style={{ marginTop: '17px' }}
							className="MUIDatePicker"
							variant="dialog"
							showTodayButton
							todayLabel="Today"
							value={coaLocationModal.input?.location_change_at || null}
							renderInput={({ inputRef, inputProps, InputProps }) => {

								const newProps = { ...inputProps }

								newProps.readOnly = false

								return (
									<TextBox ref={inputRef} endAdornment={InputProps?.endAdornment} {...newProps} />
								)
							}}
							onChange={(date) => {
								setCoaLocationModal({
									...coaLocationModal,
									input: {
										...coaLocationModal.input,
										location_change_at: date,
									},
								})
							}}
						/>
					</FormControl>

					<FormControl style={{ marginLeft: '1em', width: '20em' }}>
						<Label id="final-cost-label" style={{ fontWeight: 500 }} disableAnimation shrink>
							Tracking Number
						</Label>
						<TextBox
							id="tracking_number"
							name="tracking_number"
							multiline
							value={coaLocationModal.input?.tracking_number || ''}
							placeholder={''}
							inputProps={{ maxLength: 255 }}
							onChange={(e) => {
								setCoaLocationModal({
									...coaLocationModal,
									input: {
										...coaLocationModal.input,
										tracking_number: e.target.value.trim(),
									},
								})
							}}
						/>
					</FormControl>
				</div>

				<div>


					

					<div
						style={{
							display: 'flex',
							marginTop: '2em',
							justifyContent: 'space-between',
						}}
					>
						<h1 className="card-title">
							Associated Files
							{coaLocationModal.input?.files?.filter(e => !e.delete)?.length ? ` (${coaLocationModal.input?.files?.filter(e => !e.delete)?.length})` : ''}
						</h1>

						<ChooseImageButton
							style={{ height: '36px', marginLeft: '1em' }}
							color="primary"
							variant="contained"
							onClick={() => {
								setUploadModal(true)
							}}
						>
							Add a File
						</ChooseImageButton>
					</div>

					<TableContainer>
						<Table>
							<TableHead>
								<TableRow>
									<TableCell></TableCell>
									<TableCell align="left">Type</TableCell>
									<TableCell align="left">Filename &amp; Description</TableCell>
									<TableCell align="left">
										Uploaded Date
										<IconButton size="small" disabled>
											<ArrowDownwardIcon style={{ fontSize: '1rem', marginBottom: '.2em' }} />
										</IconButton>
									</TableCell>
									<TableCell align="left">Size</TableCell>
									<TableCell align="left">User</TableCell>
									<TableCell align="left"></TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{coaLocationModal.input?.files?.filter(e => !e.delete).sort((a, b) => b?.created_at - a?.created_at)?.map((row) => (
									<TableRow key={row.id || row.filename}>
										<TableCell>{getFileType(row.filetype)}</TableCell>
										<TableCell>{typeof row.fileCategory === "string" ? row.fileCategory : row.fileCategory?.value}</TableCell>
										<TableCell style={{ maxWidth: '50em', overflowX: 'scroll' }}>
											<ListItem style={{ padding: '0' }}>
												<ListItemText
													primary={row.filename}
													secondary={shorten(row.description, 240)}
												/>
											</ListItem>
										</TableCell>
										<TableCell style={{ minWidth: '10em' }}>
											{formatDate(row.created_at, 'MMM d, yyyy')}
										</TableCell>
										<TableCell>{readableBytes(row.filesize)}</TableCell>
										<TableCell style={{ minWidth: '15em' }}>
											<Thumbnail
												name={row.user?.first_name + ' ' + row.user?.last_name}
												detail={row.user?.gallery}
												avatar={row.user?.imgUrl}
												type="contact"
											></Thumbnail>
										</TableCell>
										<TableCell>
											<IconButton
												aria-label="More"
												style={{
													padding: '6px',
													marginRight: '-9px',
												}}
												onClick={(e) => {
													e.preventDefault()
													e.stopPropagation()
													setCurrentFile({
														...row,
														file_category_id: row.fileCategory.id
													})
													handleFileClick(e)
												}}
												size="large">
												<MoreHorizIcon />
											</IconButton>
										</TableCell>
									</TableRow>
								))}
								{coaLocationModal.input?.files?.filter(e => !e.delete)?.length === 0 ? (
									<TableRow>
										<TableCell />
										<TableCell>No Files</TableCell>
										<TableCell />
										<TableCell />
										<TableCell />
										<TableCell />
										<TableCell />
									</TableRow>
								) : null}
							</TableBody>
						</Table>
					</TableContainer>
				</div>
			</div>

			<Menu id="simple-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleFileClose}>

				{currentRow && currentFile?.id ?
					<MenuItem
						onClick={(e) => {

							props.client.query({
								query: GET_PREVIEW_LINK,
								variables: {
									id: currentFile.id
								}
							}).then(result => {

								if (result.data.getPreviewLink)
									window.open(result.data.getPreviewLink, '_blank')
								else
									openSnackbar(severity.ERROR, "Error - Unauthorized")


							}).catch(error => {
								openSnackbar(severity.ERROR, "Could not preview file")
							})

							handleFileClose()
						}}
					>
						Open
					</MenuItem>
					: null}

				{currentRow && currentFile?.id ?
					<MenuItem
						onClick={(e) => {

							props.client.query({
								query: GET_DOWNLOAD_LINK,
								variables: {
									id: currentFile.id
								}
							}).then(result => {

								if (result.data.getDownloadLink)
									window.location.href = result.data.getDownloadLink
								else
									openSnackbar(severity.ERROR, "Error - Unauthorized")


							}).catch(error => {
								openSnackbar(severity.ERROR, "Could not download file.")
							})

							handleFileClose()
						}}
					>
						Download
					</MenuItem>
					: null}

				{currentRow && currentFile?.id ?
					<MenuItem
						onClick={(e) => {
							setEditMode(true)
							handleFileClose()
						}}
					>
						Edit File
					</MenuItem>
					: null}

				{currentRow && currentFile?.id ?
					<MenuItem
						onClick={(e) => {
							setInfoObject(currentFile)
							handleFileClose()
						}}
					>
						Information
					</MenuItem>
					: null}

				<MenuItem
					onClick={(e) => {
						handleFileClose()

						if (currentRow && currentFile?.id) {

							// new location
							setCoaLocationModal({
								open: true,
								input: {
									...coaLocationModal.input,
									files: coaLocationModal.input.files.map(e => {
										if (e.key == currentFile.key) {
											return {
												...e,
												delete: true,
											}
										} else return e
									})
								}
							})

						} else {
							// new location
							setCoaLocationModal({
								open: true,
								input: {
									...coaLocationModal.input,
									files: coaLocationModal.input.files.filter(e => e.key != currentFile.key)
								}
							})
						}
					}}
				>
					{currentRow && currentFile?.id ? 'Delete' : 'Remove'}
				</MenuItem>

			</Menu>

		</TransitionsModal>

		<Menu
			keepMounted
			open={state.mouseY !== null}
			onClose={handleClose}
			anchorReference="anchorPosition"
			anchorPosition={
				state.mouseY !== null && state.mouseX !== null
					? { top: state.mouseY, left: state.mouseX }
					: undefined
			}
		>
			<MenuItem onClick={() => handleClose('edit')}>View/Edit</MenuItem>
			<MenuItem onClick={() => handleClose('delete')}>Delete</MenuItem>
			<MenuItem onClick={() => handleClose('information')}>Info</MenuItem>
		</Menu>

		<InfoCard
			open={!!infoObject}
			object={infoObject}
			setInfoModal={() => setInfoObject(null)}
			allAttributes
		/>

		<UploadModal
			titleOverride="Art CoA Location"
			open={uploadModal || editMode}
			setOpen={() => {
				setUploadModal(false)
				setEditMode(false)
				setCurrentFile(null)
			}}
			object="art"
			objectId={props.art.id}
			atPrivateObject={props.atPrivateObject}
			fileObjectId={6}
			fileId={currentFile?.id}
			editMode={editMode}
			fileInput={currentFile}
			locationModal={coaLocationModal}
			setLocationModal={setCoaLocationModal}
			files={currentRow?.files || []}
			setFiles={(files) => setCoaLocationModal({
				...coaLocationModal,
				input: {
					...coaLocationModal.input,
					files: files
				}
			})}
		/>

		<ConfirmationDialog
			open={toggleUserDialog}
			handleClose={() => setToggleUserDialog(false)}
			title={'Are you sure?'}
			acceptText={"Delete"}
			text={"This will delete all associated files, as well as this location history entry."}
			onYes={() => {
				deleteArtCoaLocation({
					variables: {
						id: currentRow?.id,
					},
				})
			}}
		/>
	</>
}

export default withApollo(ArtCoaLocation)
